import { useState,useRef } from "react";
import { supabase } from "../supabaseClient";


function SpotSheet({ spot, spots, setSpots, setSelectedSpot, visibleSpots, setVisibleSpots, userLocation, onClose, user, setShowAuth }) {
  const [showFullscreen, setShowFullscreen] = useState(false);
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${spot.lat},${spot.lng}`;
  const startY = useRef(null);

  

  const handleTouchStart = (e) => {
  startY.current = e.touches[0].clientY;
};





const handleTouchMove = (e) => {
  if (!startY.current) return;

  const currentY = e.touches[0].clientY;
  const diff = currentY - startY.current;

  if (diff > 120) {
    onClose();
    startY.current = null;
  }
};

const handleTouchEnd = () => {
  startY.current = null;
};

const handleVote = async (voteType) => {

  if (!user) {
    onClose();
    setShowAuth(true);
    return;
  }

  // Get existing vote
  const { data: existingVotes, error } = await supabase
    .from("spot_votes")
    .select("*")
    .eq("spot_id", spot.id)
    .eq("user_id", user.id);

  if (error) {
    console.error(error);
    return;
  }

  const existingVote = existingVotes?.[0] || null;

  let updatedSpot = { ...spot };

  /*
  |--------------------------------------------------------------------------
  | CASE 1 — REMOVE EXISTING VOTE
  |--------------------------------------------------------------------------
  */
  if (existingVote && existingVote.vote_type === voteType) {

    const { error: deleteError } = await supabase
      .from("spot_votes")
      .delete()
      .eq("id", existingVote.id);

    if (deleteError) {
      console.error(deleteError);
      alert(deleteError.message);
      return;
    }

    updatedSpot[voteType] =
      Math.max(
        0,
        Number(updatedSpot[voteType] || 0) - 1
      );
  }

  /*
  |--------------------------------------------------------------------------
  | CASE 2 — SWITCH VOTE
  |--------------------------------------------------------------------------
  */
  else if (existingVote) {

    const { error: updateError } = await supabase
      .from("spot_votes")
      .update({ vote_type: voteType })
      .eq("id", existingVote.id);

    if (updateError) {
      console.error(updateError);
      alert(updateError.message);
      return;
    }

    updatedSpot[existingVote.vote_type] =
      Math.max(
        0,
        Number(updatedSpot[existingVote.vote_type] || 0) - 1
      );

    updatedSpot[voteType] =
      Number(updatedSpot[voteType] || 0) + 1;
  }

  /*
  |--------------------------------------------------------------------------
  | CASE 3 — FIRST VOTE
  |--------------------------------------------------------------------------
  */
  else {

    const { error: insertError } = await supabase
      .from("spot_votes")
      .insert([
        {
          spot_id: spot.id,
          user_id: user.id,
          vote_type: voteType
        }
      ]);

    if (insertError) {
      console.error(insertError);
      alert(insertError.message);
      return;
    }

    updatedSpot[voteType] =
      Number(updatedSpot[voteType] || 0) + 1;
  }

  /*
  |--------------------------------------------------------------------------
  | UPDATE SPOT COUNTS
  |--------------------------------------------------------------------------
  */
  const { error: spotUpdateError } = await supabase
    .from("spots")
    .update({
      butter: updatedSpot.butter || 0,
      busted: updatedSpot.busted || 0
    })
    .eq("id", spot.id);

  if (spotUpdateError) {
    console.error(spotUpdateError);
    return;
  }

  /*
  |--------------------------------------------------------------------------
  | SYNC LOCAL STATE
  |--------------------------------------------------------------------------
  */
  const updatedSpots = spots.map((s) =>
    s.id === spot.id ? updatedSpot : s
  );

  const updatedVisibleSpots = visibleSpots.map((s) =>
    s.id === spot.id ? updatedSpot : s
  );

  setSpots(updatedSpots);
  setVisibleSpots(updatedVisibleSpots);
  setSelectedSpot(updatedSpot);

};


const getDistanceMiles = (lat1, lon1, lat2, lon2) => {
  const R = 3958.8; // Earth radius in miles

  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) *
    Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
};

 let distance = null;

if (userLocation) {
  distance = getDistanceMiles(
    userLocation.lat,
    userLocation.lng,
    spot.lat,
    spot.lng
  ).toFixed(1);
}

const handleShare = async () => {

  const shareUrl = `${window.location.origin}?spot=${spot.id}`;

  // Native mobile/web share
  if (navigator.share) {

    try {

      await navigator.share({
        title: spot.name,
        text: `Check out this skate spot on SkateAtlas`,
        url: shareUrl
      });

    } catch (err) {
      console.log("Share cancelled");
    }

  } else {

    // fallback copy
    await navigator.clipboard.writeText(shareUrl);

    alert("Spot link copied to clipboard!");

  }

};

  const displaySpot = spot;

  return (
   <div style={sheetStyle}
    onTouchStart={handleTouchStart}
    onTouchMove={handleTouchMove}
    onTouchEnd={handleTouchEnd}
   >

    <div style={grabHandle} />

      <button onClick={onClose} style={closeStyle}>
        x
      </button>

      {spot.photo_url && (
  <img
    src={spot.photo_url}
    alt={spot.name}
    style={photoStyle}
    onClick={() => setShowFullscreen(true)}
  />
)}
      <div style={titleStyle}>{spot.name}</div>

      <p style={creatorStyle}>
        Added by {spot.username || "unknown"}
      </p>

      <div style={typeStyle}>
        {spot.type.charAt(0).toUpperCase() + spot.type.slice(1)}
      </div>

       {distance && (
  <p style={distanceStyle}>
    📍 {distance} mi away
  </p>
)}

      <div style={voteContainer}>
  <button style={voteButton} onClick={() => handleVote("butter")}>
    🧈 Butter ({displaySpot.butter || 0})
  </button>

  <button style={voteButton} onClick={() => handleVote("busted")}>
    🚫 Busted ({displaySpot.busted || 0})
  </button>
 
</div>

      <a
  href={directionsUrl}
  target="_blank"
  rel="noopener noreferrer"
  style={directionsButton}
>
   Get Directions
</a>

 <button onClick={handleShare} style={shareButtonStyle}>
  Share
</button>

   {showFullscreen && (
    <div style={fullscreenOverlay} onClick={() => setShowFullscreen(false)}>
      <img src={spot.photo_url} alt="fullscreen" style={fullscreenImage} />
   </div>
)}
    </div>
  );
}

const sheetStyle = {
  position: "fixed",
  bottom: 0,
  left: 0,
  width: "100%",
  minHeight: "40vh",
  maxHeight: "75vh",
  overflowY: "auto",
  background: "#1c1c1e",
  padding: "24px",
  paddingBottom: "calc(24px + env(safe-area-inset-bottom))",
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
  zIndex: 9999,
  boxShadow: "0 -10px 30px rgba(0,0,0,0.5)",
};

const grabHandle = {
  width: "40px",
  height: "5px",
  background: "#636366",
  borderRadius: "3px",
  margin: "0 auto 16px auto",
};

const titleStyle = {
  fontSize: "40px",
  fontWeight: "700",
  color: "white",
};

const typeStyle = {
  fontSize: "24px",
  color: "#8e8e93",
  marginBottom: "12px",
};

const photoStyle = {
  width: "100%",
  height: "180px",
  objectFit: "cover",
  borderRadius: "12px",
  marginTop: "20px",
};

const fullscreenOverlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.95)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 20000,
};

const fullscreenImage = {
  maxWidth: "95%",
  maxHeight: "90%",
  borderRadius: "12px",
};

const closeStyle = {
  position: "absolute",
  right: "16px",
  top: "16px",
  background: "rgba(255,255,255,0.1)",
  border: "none",
  borderRadius: "8px",
  color: "white",
  padding: "6px 15px",
  cursor: "pointer"
};

const voteContainer = {
  display: "flex",
  justifyContent: "space-between",
  marginTop: "16px",
};

const voteButton = {
  flex: 1,
  padding: "10px",
  margin: "0 5px",
  borderRadius: "10px",
  border: "none",
  fontSize: "14px",
  fontWeight: "600",
  cursor: "pointer",
};

const creatorStyle = {
  color: "#8e8e93",
  fontSize: "14px",
  marginBottom: "8px"
};

const distanceStyle = {
  color: "#c7c7cc",
  fontSize: "16px",
  marginTop: "10px",
};

const directionsButton = {
  display: "block",
  width: "100%",
  marginTop: "14px",
  padding: "14px",
  borderRadius: "12px",
  background: "#0a84ff",
  color: "white",
  fontWeight: "700",
  textAlign: "center",
  textDecoration: "none",
  fontSize: "16px",
};

const shareButtonStyle = {
  display: "block",
  width: "100%",
  marginTop: "14px",
  padding: "14px",
  borderRadius: "12px",
  background: "#0a84ff",
  color: "white",
  fontWeight: "700",
  textAlign: "center",
  textDecoration: "none",
  fontSize: "16px",
};

export default SpotSheet;